import { render, staticRenderFns } from "./EditSocialAgent.vue?vue&type=template&id=529b60c0&"
import script from "./EditSocialAgent.vue?vue&type=script&lang=js&"
export * from "./EditSocialAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports